<template>
  <page layout="tabbed">
    <page-header-new
      :title="$t('Engagement_Categories_Title')"
      :breadcrumbs="breadcrumbs"
    >
      <template slot="actions">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="createEngagementCategory"
          v-if="$can('createProjectItem')"
          data-qa="add-category-button"
        >
          {{ createButtonLabel }}
        </el-button>
      </template>
    </page-header-new>
    <page-tabs :tabs="tabs"></page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'
import { isEmbedded } from '@/core/utils/EmbeddedPage'

export default {
  name: 'EngagementCategoriesPage',
  components: { PageTabs, PageHeaderNew, Page },
  methods: {
    createEngagementCategory() {
      this.$router.push(projectRoute({ name: 'EngagementCategoryCreate' }))
    }
  },
  computed: {
    createButtonLabel() {
      return isEmbedded()
        ? this.$t('Engagement_Category_Create_Embedded')
        : this.$t('Engagement_Category_Create')
    },
    breadcrumbs() {
      return [
        { label: this.$t('Campaigns_Breadcrumb_Campaigns') },
        { label: this.$t('Engagement_Categories_Title') }
      ]
    },
    tabs() {
      return [
        {
          title: this.$t('Engagement_Categories_Tab_Title'),
          route: projectRoute({ name: 'EngagementCategoriesTab' })
        }
      ]
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/EngagementCategoriesPage.vue